import {
  POST_ACTION_BLOCK_ITEM,
  POST_ACTION_BLOCK_USER,
  POST_ACTION_CONNECT_REQUEST,
  POST_ACTION_UNBLOCK_ITEM,
  POST_ACTION_UNBLOCK_USER,
} from '../../NewsboardPostHeader.constants'

export const POST_BLOCK_STATUS = 1

export const POST_UNBLOCK_STATUS = 0

export const NOTIFICATION_TRANSLATION_KEYS = {
  [POST_ACTION_BLOCK_ITEM]: 'Notification.NewsboardPostBlockedKey',
  [POST_ACTION_BLOCK_USER]: 'Notification.NewsboardPostUserBlockedKey',
  [POST_ACTION_CONNECT_REQUEST]:
    'Notification.NewsboardPostRequestConnectedKey',
  [POST_ACTION_UNBLOCK_ITEM]: 'Notification.NewsboardPostUnblockedKey',
  [POST_ACTION_UNBLOCK_USER]: 'Notification.NewsboardPostUserUnblockedKey',
}
